import React, { useContext } from 'react';

export const ConfirmStockLevelsContext = React.createContext({});
export const useConfirmStockLevelsContext = () => useContext(ConfirmStockLevelsContext);
